import React, { useState } from "react";
import { createHubPost } from "@/api";
import { errMsg } from "@/hooks/useHubSession";

export function NewPost({ slug, withSession, showToast, onPosted }) {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { onPosted(await withSession((t) => createHubPost(t, slug, { title, body }))); setTitle(""); setBody(""); }
    catch (err) { showToast(errMsg(err), "error"); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="card-tile space-y-3" data-testid="new-post-form">
      <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Start a discussion" minLength={3} maxLength={120} required
        className="w-full bg-transparent font-display text-lg outline-none" data-testid="new-post-title" />
      <textarea value={body} onChange={(e) => setBody(e.target.value)} placeholder="Share something with the hub (optional)" maxLength={5000}
        className="w-full bg-[#12131C] border border-[#2A2E45] rounded-xl px-3 py-2 text-sm h-20 outline-none" data-testid="new-post-body" />
      <div className="flex justify-end"><button disabled={busy} className="btn-tactile btn-flame text-sm" data-testid="new-post-submit">{busy ? "Posting…" : "Post"}</button></div>
    </form>
  );
}
